
import { React, useState, useEffect } from "react";
export const Clientes = () => {


    return (


        <section className='margen1 bg-[#F8FAFF] dark:bg-[#050610]'>

            <h1 className='titulo1 text-center'>
                Nuestros clientes
            </h1>


            <div className='mt-[3rem] mb-7'>

                <div className='flex justify-center '>


                    <div className="flex grid grid-cols-1 lg:grid-cols-3 gap-16 lg:gap-16 justify-items-center items-center">
                        <div > <img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/pepsi.svg"} className='pepsi' alt="Pepsi" /></div>
                        <div ><img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/unilever.svg"} className='unilever' alt="Unilever" /></div>
                        <div > <img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/afa.png"} className='afa' alt="A.F.A" /></div>
                        <div > <img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/Logo_Banco_Supervielle.svg"} className='supervielle' alt="Banco Supervielle" /></div>
                        <div > <img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/tiendabrando.svg"} className='tiendabrando' alt="TiendaBrando" /></div>
                        <div  > <img src={process.env.REACT_APP_URL_FOLDER + "/./imagenes/correo-argentino.svg"} className='correoArgentino' alt="Correo argentino" /></div>
                    </div>
                </div>
            </div>
        </section>


    );
};


/*
    recomendaciones fotos gente y estrellitas o nuestros clientes.

*/